/**
 * Formata uma data no formato 'dd/MM/yyyy HH:mm'.
 * @param {string | null} dataAniversario - A data em formato ISO ou string, ou null.
 * @returns {string} - A data formatada ou uma string vazia caso a entrada seja inválida.
 */
export default function CalculateYear(dataAniversario: string | null): string {
  if (!dataAniversario) {
    return ''; // Retorna vazio se for null ou string vazia
  }

  try {
    const currentYear = new Date().getFullYear();
    const result = currentYear - Number(dataAniversario.split("-")[0]);
    return result + ' anos';
   
  } catch (error) {
    console.error('Erro ao calcular idade:', error);
    return ''; // Retorna vazio em caso de erro
  }
}
